import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-541d80a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本文", -1))
const _hoisted_2 = { class: "speaker" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "設問", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, _toDisplayString(_ctx.situation), 1),
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(item.speaker), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(item.text), 1)
      ]))
    }), 128)),
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionList, (item, index) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "question",
        key: index
      }, _toDisplayString(item), 1))
    }), 128))
  ]))
}